export default __webpack_public_path__ + "static/media/Tunic of Crimson Slaughter (nm).bc85dcf0.jpg";